import api from "../../../api/axios";

// Feature-local wrapper for GET /api/companies/?search=<q>&page=1.
// Third feature-local copy of the same call (Phase 10's
// companyFinder/api/companies.js and Phase 11's
// companyJoinRequest/api/companies.js are the prior two).
// Extraction into shared/api/companies.js is deliberately deferred
// — Phase 15's architectural goal is to validate dependent-resource
// coordination, NOT shared API extraction. See
// migration/phase15-dependent-resource-plan.md §13.
//
// DRF SearchFilter performs case-insensitive icontains on
// CompanyViewSet.search_fields = ("name", "description", "city").
// Returns the raw paginated envelope { count, next, previous, results }.
export const searchCompanies = (query, { signal } = {}) =>
  api
    .get("/companies/", {
      params: { search: query, page: 1 },
      signal,
    })
    .then((res) => res.data);
